import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Sun, Coffee, Activity, Droplets, Dumbbell, ShieldPlus } from 'lucide-react';
export function Science() {
  const principles = [{
    icon: <Moon className="w-5 h-5" data-id="element-654" />,
    text: 'Sueño y ritmo circadiano'
  }, {
    icon: <Coffee className="w-5 h-5" data-id="element-655" />,
    text: 'Ayuno intermitente'
  }, {
    icon: <Sun className="w-5 h-5" data-id="element-656" />,
    text: 'Exposición a luz natural'
  }, {
    icon: <Activity className="w-5 h-5" data-id="element-657" />,
    text: 'Manejo del estrés'
  }, {
    icon: <Droplets className="w-5 h-5" data-id="element-658" />,
    text: 'Hidratación y electrolitos'
  }, {
    icon: <Dumbbell className="w-5 h-5" data-id="element-659" />,
    text: 'Actividad física básica'
  }, {
    icon: <ShieldPlus className="w-5 h-5" data-id="element-660" />,
    text: 'Suplementación responsable'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt border-y border-brand-border" data-id="element-661">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-662">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-663">
          <h2 className="text-3xl font-bold text-white mb-8" data-id="element-664">
            Basado en principios estudiados de:
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-665">
            {principles.map((p, idx) => <div key={idx} className="flex items-center gap-2 bg-brand-card border border-brand-border px-4 py-2 rounded-full text-brand-muted text-sm font-medium" data-id="element-666">
                <span className="text-brand-cyan" data-id="element-667">{p.icon}</span>
                {p.text}
              </div>)}
          </div>

          <div className="bg-brand-card/50 rounded-2xl p-8 border border-brand-border/50 max-w-[700px] mx-auto" data-id="element-668">
            <p className="text-brand-muted leading-relaxed" data-id="element-669">
              BIO-X 90 no promete curas ni resultados médicos. Organiza
              principios ampliamente estudiados de bienestar, sueño, nutrición,
              manejo del estrés y rendimiento diario en un sistema práctico de
              90 días.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}